import { useEffect, useState } from 'react';
import { Input } from '@repo/ui';

interface SubjectInputProps {
  value: string;
  onChange: (val: string) => void;
  error?: string;
}

export const SubjectInput = ({ value, onChange, error }: SubjectInputProps) => {
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  return (
    <Input
      className="!py-2"
      value={localValue}
      label="Subject"
      fullWidth
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => onChange(localValue)}
      error={error}
    />
  );
};
